import styled, { breakpoints } from '../../../styles/theme';
import NeedHelpSectionTemplate from './NeedHelpSectionTemplate';
import { rem } from 'polished';

const NeedHelpSectionStyled = styled(NeedHelpSectionTemplate)`
    padding: ${rem('20px')};
    z-index: 1001;

    .need-help-section__title {
        font-size: ${rem('18px')};
        text-transform: uppercase;
        margin: ${rem('5px')} 0;
        line-height: initial;
    }

    .need-help-section__closeIcon {
        visibility: visible;

        svg {
            width: ${rem(15)};
            height: ${rem(15)};
        }

        position: absolute;
        top: ${rem(10)};
        right: ${rem(10)};

        @media (min-width: ${breakpoints.md}px) {
            visibility: hidden;
        }
    }

    .need-help-section__link {
        margin: 0;
        margin-left: 0 !important;
        line-height: ${rem('20px')};
        color: ${({ theme }) => theme.colors.primary} !important;
        display: inline-flex;
        flex-direction: row !important;
        align-items: center !important;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        span {
            flex-shrink: 0;
        }

        &.need-help-section__phone {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &:hover {
            color: ${({ theme }) => theme.colors.primaryHover};
        }

        svg {
            path {
                color: ${({ theme }) => theme.colors.primary} !important;
            }
        }
    }

    .need-help-section__text {
        margin: 0 !important;
        line-height: ${rem('20px')};
    }

    .need-help-section__contact {
        margin-bottom: ${rem('20px')};
    }

    .need-help-section__chevron {
        svg {
            vertical-align: top;
        }

        path {
            fill: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export default NeedHelpSectionStyled;
